import {Sconti} from '../../../models/sconti';
import {Injectable} from '@angular/core';
import { ScontiGuest } from 'src/app/models/scontiGuest';

@Injectable({
  providedIn: 'root'
})
export class ScontiStore {
  showLoader: boolean;

  title = 'Sconti';
  viewAllPath = '/menu/viewall/sconti';
  records: Sconti[];
  sortedRecords: Sconti[];
  totalRecords: number;

 // isGuest:boolean=true;
  sortedRecordsGuest: ScontiGuest[];
  recordsGuest: ScontiGuest[];

 
  constructor() {
    this.records = [];
    this.sortedRecords = [];
  }

  load(records: Sconti[]) {
    this.records = records;
    this.sortedRecords = this.records.slice();
  }

  loadGuest(records: ScontiGuest[]) {
    this.recordsGuest = records;
    this.sortedRecordsGuest = this.recordsGuest.slice();
  }
}
